var map = {
	"./ai-chatbot-1.webp": 1144,
	"./ai-chatbot-10.webp": 8944,
	"./ai-chatbot-2.webp": 1317,
	"./ai-chatbot-3.webp": 7146,
	"./ai-chatbot-4.webp": 8343,
	"./ai-chatbot-5.webp": 7332,
	"./ai-chatbot-6.webp": 4049,
	"./ai-chatbot-7.webp": 4022,
	"./ai-chatbot-8.webp": 5843,
	"./ai-chatbot-9.webp": 6432,
	"./cinematic-blogger-1.webp": 8138,
	"./cinematic-blogger-10.webp": 4646,
	"./cinematic-blogger-2.webp": 7659,
	"./cinematic-blogger-3.webp": 4840,
	"./cinematic-blogger-4.webp": 4033,
	"./cinematic-blogger-5.webp": 9302,
	"./cinematic-blogger-6.webp": 4903,
	"./cinematic-blogger-7.webp": 6692,
	"./cinematic-blogger-8.webp": 2749,
	"./cinematic-blogger-9.webp": 6338,
	"./cv-reviewer-1.webp": 3651,
	"./cv-reviewer-2.webp": 6226,
	"./docket-email-intelligence-1.webp": 9169,
	"./field-visit-1.webp": 3546,
	"./field-visit-2.webp": 3067,
	"./field-visit-3.webp": 248,
	"./field-visit-4.webp": 5793,
	"./field-visit-5.webp": 1062,
	"./floor-plan-1.webp": 4086,
	"./floor-plan-2.webp": 8407,
	"./floor-plan-3.webp": 7396,
	"./floor-plan-4.webp": 1381,
	"./floor-plan-5.webp": 3562,
	"./floor-plan-6.webp": 5931,
	"./floor-plan-7.webp": 1208,
	"./medical-and-health-service-1.webp": 3058,
	"./medical-and-health-service-2.webp": 707,
	"./medical-and-health-service-3.webp": 304,
	"./medical-and-health-service-4.webp": 9081,
	"./medical-and-health-service-5.webp": 7646,
	"./medical-and-health-service-6.webp": 6287,
	"./medical-and-health-service-7.webp": 6044,
	"./neon-board-1.webp": 8605,
	"./neon-board-2.webp": 5776,
	"./neon-board-3.webp": 1539,
	"./neon-board-4.webp": 6254,
	"./neon-board-5.webp": 2281,
	"./neon-board-6.webp": 8012,
	"./neural-ai-1.webp": 8172,
	"./neural-ai-10.webp": 5436,
	"./neural-ai-2.webp": 8889,
	"./neural-ai-3.webp": 9166,
	"./neural-ai-4.webp": 3555,
	"./neural-ai-5.webp": 1344,
	"./neural-ai-6.webp": 9245,
	"./neural-ai-7.webp": 2834,
	"./neural-ai-8.webp": 5047,
	"./neural-ai-9.webp": 3188,
	"./prayosha-construction-1.webp": 5233,
	"./prayosha-construction-10.webp": 543,
	"./prayosha-construction-2.webp": 7124,
	"./prayosha-construction-3.webp": 1831,
	"./prayosha-construction-4.webp": 3306,
	"./prayosha-construction-5.webp": 7333,
	"./prayosha-construction-6.webp": 8408,
	"./prayosha-construction-7.webp": 3755,
	"./prayosha-construction-8.webp": 3646,
	"./prayosha-construction-9.webp": 3369,
	"./product-gallery-1.webp": 8136,
	"./product-gallery-2.webp": 7541,
	"./product-gallery-3.webp": 10,
	"./product-gallery-4.webp": 5639,
	"./product-gallery-5.webp": 1460,
	"./project-management-1.webp": 4235,
	"./project-management-2.webp": 7386,
	"./project-management-3.webp": 8885,
	"./project-management-4.webp": 7092,
	"./project-management-5.webp": 103,
	"./proposal-1.webp": 5858,
	"./proposal-2.webp": 9635,
	"./proposal-3.webp": 5792,
	"./proposal-4.webp": 4937,
	"./proposal-5.webp": 4046,
	"./rag-deal-1.webp": 5783,
	"./rag-deal-2.webp": 6534,
	"./rag-deal-3.webp": 1265,
	"./rag-deal-4.webp": 5720,
	"./rag-deal-5.webp": 8539,
	"./rag-deal-6.webp": 9018,
	"./teqnodux-logo.png": 6316,
	"./walkthrough-1.webp": 1490,
	"./walkthrough-2.webp": 8915,
	"./walkthrough-3.webp": 5072,
	"./walkthrough-4.webp": 4217,
	"./walkthrough-5.webp": 3326,
	"./wawasensei-white.png": 4083
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2845;